import axios from 'axios'
import axiosRetry from 'axios-retry'
import { deserialize } from 'deserialize-json-api'

const SiteStore = {
  namespaced: true,
  state: {
    site: {},
    siteExtensionPermissions: []
  },
  mutations: {
    setSiteCommon (state, siteCommon) {
      state.site.id = siteCommon.id
      state.site.name = siteCommon.name
      state.site.logo = siteCommon.logo
      state.site.favicon = siteCommon.favicon
    },
    setSite (state, site) {
      state.site = site
    },
    setSiteExtensionPermissions (state, permissions) {
      state.siteExtensionPermissions = [...permissions]
    }
  },
  actions: {
    fetchSiteReference (context) {
      axiosRetry(axios, { retries: 2 })
      return axios.get('/api/site_reference').then(
        ({ data }) => {
          const site = deserialize(data).data
          const permissions = site.siteExtensionPermissions || []
          context.commit('setSite', site)
          context.commit('setSiteExtensionPermissions', permissions)
        },
        (error) => {
          if (error.response.status === 403) {
            context.commit('errorPage/setForbidden', true, { root: true })
          }

          const payload = {
            status: error.response.status,
            message: `サイト情報の取得に失敗しました（${error.response.data.errors.toString()}）`
          }
          context.dispatch('SystemMessageStore/createMessage', payload, {
            root: true
          })
        }
      )
    }
  }
}

export default SiteStore
